import type { SelectOption } from '~/shared/utils/types';

import type { ExplorationVolume } from '../../types/exploration';
import { buildVolumeIdOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function VolumeIdFilter({
  volumes,
  pendingVolumeIdFilters,
  setPendingVolumeIdFilters,
  globalSearchQuery = '',
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingVolumeIdFilters: SelectOption[];
  setPendingVolumeIdFilters: (filters: SelectOption[]) => void;
  globalSearchQuery?: string;
  isDisclosureOpen?: boolean;
}) {
  const options = buildVolumeIdOptions(volumes);

  const handleChange = (volumeId: string) => {
    const selected = pendingVolumeIdFilters.some((f) => f.id === volumeId);
    if (selected) {
      setPendingVolumeIdFilters(pendingVolumeIdFilters.filter((f) => f.id !== volumeId));
    } else {
      setPendingVolumeIdFilters([
        ...pendingVolumeIdFilters,
        { id: volumeId, name: volumeId, group: 'volumeId' },
      ]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      globalSearchQuery={globalSearchQuery}
      showSectionSearch
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingVolumeIdFilters.some((f) => f.id === key)}
      onToggle={handleChange}
      showCount={false}
    />
  );
}

export function buildVolumeIdFilterOptions(volumes: ExplorationVolume[]) {
  return buildVolumeIdOptions(volumes);
}
